import React from 'react';
// Components
import SetupStream from 'components/common/SetupStream/SetupStream';

const SetupOrganizationStream = (): JSX.Element => {
  return <SetupStream />;
};

export default SetupOrganizationStream;
